import React from "react";
import { Reducer, SettingStateType, SettingDispatch } from "./reducer";

export const SettingStateContext = React.createContext<SettingStateType>({});
export const SettingDispatchContext = React.createContext<
  SettingDispatch | undefined
>(undefined);

interface SettingProviderProps {}

type SettingProviderPropsType = React.PropsWithChildren<SettingProviderProps>;

export const SettingProvider: React.FC<SettingProviderPropsType> = ({
  children,
}: SettingProviderPropsType) => {
  const [state, dispatch] = React.useReducer(Reducer, {});
  return (
    <SettingDispatchContext.Provider value={dispatch}>
      <SettingStateContext.Provider value={state}>
        {children}
      </SettingStateContext.Provider>
    </SettingDispatchContext.Provider>
  );
};

export const useSettingState = () => {
  const state = React.useContext(SettingStateContext);
  return state;
};

export const useSettingDispatch = () => {
  const dispatch = React.useContext(SettingDispatchContext);
  return dispatch;
};
